<span class="clipboard__rule">
  {{ subscriptionId() | shorten_guid }}
  <span class="clipboard__link" ngxClipboard [cbContent]="subscriptionId()">
    <div class="clipboard__icon">
      <svg-icon src="assets/images/icons/copy.svg"></svg-icon>
    </div> </span
></span>
